export default __webpack_public_path__ + "static/media/audited-by-quillhash-white.ff07666c.png";